export const print = {

  /**
   * CSS class name of the print buttons
   * @type String
   * @private
   */
  cssClassButton: 'button_print',

  /**
   * Reference to the map object.
   * @type {module:map}
   */
  map: null,

  /**
   * Initialize the print object.
   * @param {module:map} map
   * @returns {void}
   */
  init (map) {
    this.map = map;
    this._initEvents();
  },

  /**
   * Initialize the events.
   * @returns {void}
   * @private
   */
  _initEvents () {
    // note: there are two print buttons, the second is displayed when the print layout is shown.
    document.querySelectorAll('.' + this.cssClassButton)
      .forEach(button => {
        button.addEventListener('click', this._toggleLayout.bind(this));
      });
  },

  /**
   * Toggle the print layout.
   * @private
   */
  _toggleLayout () {
    this.map.map.once('rendercomplete', () => {
      // Setting the CSS classes below will lead to a re-render of the map here.
      this.map.centerView();
    });
    //  Hide the left panel before re-render the map to correctly set the new map width.
    document.querySelectorAll('.column__left, nav, .toolbar_print')
      .forEach(el => {
        el.classList.toggle('hidden');
      });
    // Set the print layout and orientation.
    document.querySelectorAll('html, body')
      .forEach(el => {
        el.classList.toggle('print-layout');
        const orientation = document.querySelector('.radio_print-orientation:checked').value;
        if (orientation === 'vertical') {
          el.classList.remove('print-layout_horizontal');
          el.classList.toggle('print-layout_vertical');
        } else {
          el.classList.remove('print-layout_vertical');
          el.classList.toggle('print-layout_horizontal');
        }
      });
  }
};